import { CommonModule } from "@angular/common";
import { Component, ElementRef, inject, OnInit, viewChild, ViewChild } from "@angular/core";
import { AbstractControl, ControlContainer, FormArray, FormBuilder, FormGroup, FormGroupDirective, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatCheckbox, MatCheckboxChange } from "@angular/material/checkbox";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { TouchedErrorStateMatcher } from "../../../shared/other/touched-form-error-state-matcher";
import { ExpenseType, TripDocumentsDto, VerificationDocuments } from "../../../dashboard/models/trip-request-models";
import { DecimalInputDirective } from "../../../shared/directives/decimal-input.directive";
import { TripRequestFormService } from "../../shared/trip-request-form.service";
import { TripRequestService } from "../../../dashboard/services/trip-request.service";
import { HttpResponse } from "@angular/common/http";
import { MatExpansionModule, MatExpansionPanel } from "@angular/material/expansion";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { MatPaginator, MatPaginatorModule } from "@angular/material/paginator";
import { PAGING_ROWS } from "../../../shared/constants/common-constants";


@Component({
  selector: 'app-trip-document',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatIconModule,
    MatCheckbox,
    DecimalInputDirective,
    MatExpansionModule,
    MatIconModule,
    MatTableModule,
    MatPaginatorModule
  ],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
  templateUrl: './trip-request-documents.component.html',
  styleUrl: './trip-request-documents.component.scss',
})

export class TripRequestDocumentsComponent implements OnInit {
    @ViewChild('tollfileUpload')
    tollfileUpload!: ElementRef;
    @ViewChild('appointmentfileUpload')
    appointmentfileUpload!: ElementRef;
    @ViewChild('parkingfileUpload')
    parkingfileUpload!: ElementRef;
    private postTripRequestFormDir = inject(FormGroupDirective);
    tripRequestFg!: FormGroup;
    appointmentDatesFr!: FormArray;
    matcher = new TouchedErrorStateMatcher();
    tollFileSelectPlaceHolder = "Upload Toll Receipts";
    appointmentFileSelectPlaceHolder = "Upload Appointment Documents";
    parkingFileSelectPlaceHolder = "Upload Parking Receipts";
    isAppVerificationDocReq = true;
    isTollDocReq = false;
    isParkingDocReq = false;
    appVerficationDocumentsDto: TripDocumentsDto[] = [];
    tollDocumentsDto: TripDocumentsDto[] = [];
    parkingDocumentsDto: TripDocumentsDto[] = [];
    tripRequestFormService = inject(TripRequestFormService);
    private tripRequestService = inject(TripRequestService);
    showTollSection = false;
    showParkingSection = false;
    displayedColumns: string[] = ['confirmationNumber', 'fileNames'];
    linkingDocuments: VerificationDocuments[] = [];
    dataSource = new MatTableDataSource<VerificationDocuments>(this.linkingDocuments);
    @ViewChild(MatPaginator) paginator!: MatPaginator;
    pageSize = PAGING_ROWS;

    ngOnInit(): void {
        this.tripRequestFg = this.postTripRequestFormDir.form.get("tripRequest") as FormGroup;
        this.appointmentDatesFr = this.tripRequestFg.get("tripAppointments") as FormArray;
    }


    get appointmentVerificationDocuments() : FormGroup {
      return this.tripRequestFg.get('appointmentVerificationDocuments') as FormGroup; 
    }

    get tollDocuments() : FormGroup {
      return this.tripRequestFg.get('tollDocuments') as FormGroup; 
    }

    get parkingDocuments() : FormGroup {
      return this.tripRequestFg.get('parkingDocuments') as FormGroup; 
    }

    bindExpenceAmountChange() {
      for(let i=0; i <= this.appointmentDatesFr.length -1; i++) {
        for(let j=0; j <= this.getAppointmentExpense(i).length -1; j++) {
          const expenseFg =  this.getAppointmentExpense(i).at(j).get('expenseAmount')!.valueChanges.subscribe(
            (value : number) => {
                if (this.getAppointmentExpense(i).at(j).get('expenseType')?.value === ExpenseType.Toll) {
                  if (value > 0) {
                      this.showTollSection = true;
                      this.setExpenseDocumentRequiredValidator(ExpenseType.Toll);
                  }
                  else {
                      this.ClearDocumentRequiredValidator(ExpenseType.Toll);
                  }
                }
                else {
                  if (value > 0) {
                      this.showParkingSection = true;
                      this.setExpenseDocumentRequiredValidator(ExpenseType.Parking);   
                  }
                  else {
                      this.ClearDocumentRequiredValidator(ExpenseType.Parking);
                  }
                }
            }
          );
        }
      }
    }

    onRowDoubleClick(panel: MatExpansionPanel, rowData: VerificationDocuments) {
      this.linkAppointmentsDocuments(rowData.fileNamesWithId);
      panel.close();
    }

    onLinkPanelOpen(){
      this.dataSource.paginator = this.paginator;
    }

    setExpenseDocumentRequiredValidator(documentType : string) {
      let documentFg;
      let validationRequired = false;
      if (documentType === ExpenseType.Toll) {
          documentFg = this.tollDocuments as FormGroup;
      }
      else if (documentType === ExpenseType.Parking) {
          documentFg = this.parkingDocuments as FormGroup;
      }
      else {
          documentFg = this.appointmentVerificationDocuments as FormGroup;
      }

      if (!documentFg.get('documentUploading')?.value && !documentFg.get('documentEmailing')?.value &&
          !documentFg.get('documentMailing')?.value && !documentFg.get('documentFaxing')?.value) {
              if (documentType === ExpenseType.Toll) {
                documentFg.get('tollDocument')?.setValidators([Validators.required]);
                documentFg.get('tollDocument')?.updateValueAndValidity();
              }
              else if (documentType === ExpenseType.Parking) {
                documentFg.get('parkingDocument')?.setValidators([Validators.required]);
                documentFg.get('parkingDocument')?.updateValueAndValidity();
              }
              validationRequired = true;
      }

      if (documentType === ExpenseType.Toll) {
          this.isTollDocReq = validationRequired;
      }
      else if (documentType === ExpenseType.Parking) {
        this.isParkingDocReq = validationRequired;
      }
      else {
        this.isAppVerificationDocReq = validationRequired;
      }
    }
    

    ClearDocumentRequiredValidator(documentType: string) {
      let validatorRequired = false;
      for(let i=0; i <= this.appointmentDatesFr.length -1; i++) {
        if (validatorRequired === false) {
          for(let j=0; j <= this.getAppointmentExpense(i).length -1; j++) {
            if (this.getAppointmentExpense(i).at(j).get('expenseType')?.value === documentType &&
                this.getAppointmentExpense(i).at(j).get('expenseAmount')?.value > 0) {
                  validatorRequired = true;
                  break;
            }
          }
        }
        if (validatorRequired) { break;}
      }

      if (!validatorRequired) {
        if (documentType === ExpenseType.Toll) {
          this.resetDocumentFileControl('tollDocuments', 'tollDocument');
          this.showTollSection = false;
        }
        else {
          this.resetDocumentFileControl('parkingDocuments','parkingDocument');
          this.showParkingSection = false;
        }
      }
    }

    resetDocumentFileControl(fgName: string, controlName: string) {
        this.isTollDocReq = fgName === 'tollDocuments' ? false : this.isTollDocReq;
        this.isAppVerificationDocReq = fgName === 'appointmentVerificationDocuments' ? false : this.isAppVerificationDocReq;
        this.isParkingDocReq = fgName === 'parkingDocuments' ? false : this.isParkingDocReq;

        const tollDocument = this.tripRequestFg.get(fgName) as FormGroup;
        tollDocument.get(controlName)?.clearValidators();
        tollDocument.get(controlName)?.markAsUntouched();
        tollDocument.get(controlName)?.markAsPristine();
        tollDocument.get(controlName)?.updateValueAndValidity();
    }
   
    getAppointmentExpense(index: number): FormArray {
        const appointmentGp = this.appointmentDatesFr.at(index) as FormGroup;
        return appointmentGp.get('tripExpenses') as FormArray;       
    }

    tollFileSelect() {
        if (this.tollfileUpload)
        this.tollfileUpload.nativeElement.click()
    }

    appointmentFileSelect() {
      if (this.appointmentfileUpload)
          this.appointmentfileUpload.nativeElement.click()
    }

    parkingFileSelect() {
      if (this.parkingfileUpload)
          this.parkingfileUpload.nativeElement.click()
    }

    onFilesSelected(event: Event, source: string) {
      const input = event.target as HTMLInputElement;
      if (!input.files) return;

      const allowedExtensions = ['.pdf', '.jpg', '.jpeg', '.png', '.txt', '.doc', '.docx', '.xls', '.xlsx'];
      const allowedMimeTypes = [
        'application/pdf', 'image/jpeg', 'image/png', 'text/plain',
        'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      ];

      const newFiles = Array.from(input.files);

      const validTypesOnly = newFiles.filter(file => {
        const extension = '.' + file.name.split('.').pop()?.toLowerCase();
        return allowedExtensions.includes(extension) || allowedMimeTypes.includes(file.type);
      });

      if (source === ExpenseType.Toll) {
          this.addTollDocuments(validTypesOnly);     
      }
      else if (source === 'appointment') {
        this.addAppointmentDocuments(validTypesOnly); 
      }
      else {
        this.addParkingDocuments(validTypesOnly); 
      }

      input.value = '';
    }

  addTollDocuments(files: File[]) {
    const uniqueNewFiles = files.filter(
        (newFile) => !this.tollDocumentsDto.some((existingFile) => existingFile.fileName === newFile.name)
    );
    const newDocuments = uniqueNewFiles.map((file, index) => ({
        documentId: 0,
        fileName: file.name,
        path: '',
        documentType: ExpenseType.Toll,
        file
      }));
    this.tollDocumentsDto.push(...newDocuments);
    const totalCount = this.tollDocumentsDto.length 
    this.tollFileSelectPlaceHolder = totalCount > 0 ? `${totalCount} file(s) selected` : 'Upload Toll Receipts';
    this.setTollDocumentFormValue(totalCount);
  }

  addParkingDocuments(files: File[]) {
    const uniqueNewFiles = files.filter(
        (newFile) => !this.parkingDocumentsDto.some((existingFile) => existingFile.fileName === newFile.name)
    );
    const newDocuments = uniqueNewFiles.map((file, index) => ({
        documentId: 0,
        fileName: file.name,
        path: '',
        documentType: ExpenseType.Parking,
        file
      }));
    this.parkingDocumentsDto.push(...newDocuments);
    const totalCount = this.parkingDocumentsDto.length 
    this.parkingFileSelectPlaceHolder = totalCount > 0 ? `${totalCount} file(s) selected` : 'Upload Parking Receipts';
    this.setParkingDocumentFormValue(totalCount);
  }

  addAppointmentDocuments(files: File[]) {
    const uniqueNewFiles = files.filter(
        (newFile) => !this.appVerficationDocumentsDto.some((existingFile) => existingFile.fileName === newFile.name)
    );
    const newDocuments = uniqueNewFiles.map((file, index) => ({
        documentId: 0,
        fileName: file.name,
        path: '',
        documentType: 'Verification',
        file
      }));
    this.appVerficationDocumentsDto.push(...newDocuments);
    const totalCount = this.appVerficationDocumentsDto.length 
    this.appointmentFileSelectPlaceHolder = totalCount > 0 ? `${totalCount} file(s) selected` : 'Upload Appointment Documents';
    this.setAppointmentVerificationFormValue(totalCount);
  }

  linkAppointmentsDocuments(fileNames: string) {
    const fileNameList: string[] = fileNames.split(','); 

    const fileObjs = fileNameList.map(value => {
      const [name, id] = value.split('|');
      return {name,id: Number(id)};
    });

    const uniqueNewFiles = fileObjs.filter(
        (newFile) => !this.appVerficationDocumentsDto.some((existingFile) => existingFile.fileName.trim() === newFile.name.trim())
    );

    const newDocuments = uniqueNewFiles.map((file, index) => ({
        documentId: 0,
        fileName: file.name.trim(),
        path: '',
        documentType: 'Verification',
        linkDocumentId: file.id
      }));
    this.appVerficationDocumentsDto.push(...newDocuments);
    const totalCount = this.appVerficationDocumentsDto.length 
    this.appointmentFileSelectPlaceHolder = totalCount > 0 ? `${totalCount} file(s) selected` : 'Upload Appointment Documents';
    this.setAppointmentVerificationFormValue(totalCount);
  }

  removeFile(index: number, source: string): void {
    if (source === ExpenseType.Toll) {
      this.tollDocumentsDto.splice(index, 1)
      const totalCount = this.tollDocumentsDto.length 
      this.tollFileSelectPlaceHolder = totalCount > 0 ? `${totalCount} file(s) selected` : 'Upload Toll Receipts';
      this.setTollDocumentFormValue(totalCount);
    }
    else if (source === 'appointment') {
      this.appVerficationDocumentsDto.splice(index, 1)
      const totalCount = this.appVerficationDocumentsDto.length 
      this.appointmentFileSelectPlaceHolder = totalCount > 0 ? `${totalCount} file(s) selected` : 'Upload Appointment Documents';        
      this.setAppointmentVerificationFormValue(totalCount);
    }
    else {
      this.parkingDocumentsDto.splice(index, 1)
      const totalCount = this.parkingDocumentsDto.length 
      this.parkingFileSelectPlaceHolder = totalCount > 0 ? `${totalCount} file(s) selected` : 'Upload Parking Receipts';
      this.setParkingDocumentFormValue(totalCount);
    }
  }

  hasError(controlName: string, errorName: string): boolean {
      const control: AbstractControl | null = this.tripRequestFg.get(`${controlName}`);
      return !!control && control.hasError(errorName) && (control.dirty || control.touched);
  }

  setAppointmentVerificationFormValue(totalCount: number) {
      const docFg = this.tripRequestFg.get('appointmentVerificationDocuments') as FormGroup;
      if (totalCount > 0) {
          docFg.get('appointmentDocument')?.setValue(this.appointmentFileSelectPlaceHolder);
          docFg.get('appointmentDocument')?.setErrors(null);
      }
      else {
        docFg.get('appointmentDocument')?.setValue(null);
      }
      docFg.get('appointmentDocument')?.updateValueAndValidity();
      docFg.get('appointmentDocument')?.markAsDirty();
      docFg.get('appointmentDocument')?.markAsTouched();
  }

  setTollDocumentFormValue(totalCount: number) {
      const tollDocFg = this.tripRequestFg.get('tollDocuments') as FormGroup;
      if (totalCount > 0) {
          tollDocFg.get('tollDocument')?.setValue(this.tollFileSelectPlaceHolder);
          tollDocFg.get('tollDocument')?.setErrors(null);
      }
      else {
        tollDocFg.get('tollDocument')?.setValue(null);
      }
      tollDocFg.get('tollDocument')?.updateValueAndValidity();
      tollDocFg.get('tollDocument')?.markAsDirty();
      tollDocFg.get('tollDocument')?.markAsTouched();
  }

  setParkingDocumentFormValue(totalCount: number) {
      const parkingDocFg = this.tripRequestFg.get('parkingDocuments') as FormGroup;
      if (totalCount > 0) {
          parkingDocFg.get('parkingDocument')?.setValue(this.parkingFileSelectPlaceHolder);
          parkingDocFg.get('parkingDocument')?.setErrors(null);
      }
      else {
        parkingDocFg.get('parkingDocument')?.setValue(null);
      }
      parkingDocFg.get('parkingDocument')?.updateValueAndValidity();
      parkingDocFg.get('parkingDocument')?.markAsDirty();
      parkingDocFg.get('parkingDocument')?.markAsTouched();
  }

  onParkingSelectionChange(event: MatCheckboxChange) {
    if (event.checked) {
      this.resetDocumentFileControl('parkingDocuments','parkingDocument');
    }
    else
    {
      const parkingDocument = this.tripRequestFg.get('parkingDocuments') as FormGroup;
      if (!parkingDocument.get('documentUploading')?.value && !parkingDocument.get('documentEmailing')?.value &&
          !parkingDocument.get('documentMailing')?.value && !parkingDocument.get('documentFaxing')?.value) { 

        for(let i=0; i <= this.appointmentDatesFr.length -1; i++) {  
          for(let j=0; j <= this.getAppointmentExpense(i).length -1; j++) {
            if (this.getAppointmentExpense(i).at(j).get('expenseType')?.value === ExpenseType.Parking &&
                this.getAppointmentExpense(i).at(j).get('expenseAmount')?.value > 0) {
                  this.isParkingDocReq = true;
                  parkingDocument.get('parkingDocument')?.setValidators([Validators.required]);
                  parkingDocument.get('parkingDocument')?.updateValueAndValidity();
                  parkingDocument.get('parkingDocument')?.setValue(null);
                  break;
            }
          }
          if (this.isParkingDocReq) {break;}
        }
      } 
    }
  }

  onTollSelectionChange(event: MatCheckboxChange) {
    if (event.checked) {
      this.resetDocumentFileControl('tollDocuments','tollDocument');
    }
    else
    {
      const tollDocument = this.tripRequestFg.get('tollDocuments') as FormGroup;
      if (!tollDocument.get('documentUploading')?.value && !tollDocument.get('documentEmailing')?.value &&
          !tollDocument.get('documentMailing')?.value && !tollDocument.get('documentFaxing')?.value) { 

        for(let i=0; i <= this.appointmentDatesFr.length -1; i++) {  
          for(let j=0; j <= this.getAppointmentExpense(i).length -1; j++) {
            if (this.getAppointmentExpense(i).at(j).get('expenseType')?.value === ExpenseType.Toll &&
                this.getAppointmentExpense(i).at(j).get('expenseAmount')?.value > 0) {
                  this.isTollDocReq = true;
                  tollDocument.get('tollDocument')?.setValidators([Validators.required]);
                  tollDocument.get('tollDocument')?.updateValueAndValidity();
                  tollDocument.get('tollDocument')?.setValue(null);
                  break;
            }
          }
          if (this.isTollDocReq) {break;}
        }
      } 
    }
  }

  onAppVerificationSelectionChange(event: MatCheckboxChange) {
    if (event.checked) {
      this.resetDocumentFileControl('appointmentVerificationDocuments','appointmentDocument');
    }
    else
    {
      const appVerificationDocument = this.tripRequestFg.get('appointmentVerificationDocuments') as FormGroup;
      if (!appVerificationDocument.get('documentUploading')?.value && !appVerificationDocument.get('documentEmailing')?.value &&
          !appVerificationDocument.get('documentMailing')?.value && !appVerificationDocument.get('documentFaxing')?.value) { 
          this.isAppVerificationDocReq = true;
          appVerificationDocument.get('appointmentDocument')?.setValidators([Validators.required]);
          appVerificationDocument.get('appointmentDocument')?.updateValueAndValidity();
          appVerificationDocument.get('appointmentDocument')?.setValue(null);
      }
    } 
  }

  downloadVerificationFile() {
    this.tripRequestService.downloadVerificationFile().subscribe((response: HttpResponse<Blob>) => {
      const blob = response.body;
      if (!blob) return;

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'VerificationFile.pdf';
      a.click();
      window.URL.revokeObjectURL(url);
    });
  }

}